$(document).ready(function () {
  console.log("Launched builder script!");

  $(".pp_var_qty_adjust").click(function () {
    var variantId = $(this).attr("data-variant");
    var qty = parseFloat(
      $(this).closest(".pp_builder_var_qty").find(".pp_var_qty_value").html()
    );
    var mode = $(this).attr("data-mode");
    if (mode == "plus") {
      qty++;
    } else if (mode == "minus") {
      if (qty > 0) {
        qty--;
      }
    }
    $(this).closest(".pp_builder_var_qty").find(".pp_var_qty_value").html(qty);
    if (qty > 0) {
      $(this)
        .closest(".pp_builder_var_qty")
        .find(".pp_var_qty_adjust.minus")
        .css("opacity", "1");
      $(this)
        .closest(".pp_builder_var_qty")
        .find(".pp_var_qty_value")
        .css("opacity", "1");
      $(this).closest(".pp_builder_var_qty").addClass("hasItem");
    } else {
      $(this)
        .closest(".pp_builder_var_qty")
        .find(".pp_var_qty_adjust.minus")
        .css("opacity", "0");
      $(this)
        .closest(".pp_builder_var_qty")
        .find(".pp_var_qty_value")
        .css("opacity", "0");
      $(this).closest(".pp_builder_var_qty").removeClass("hasItem");
    }

    setVariantContent(variantId);
    calculateTotalItems();
  });

  function setVariantContent(variantId) {
    $(".pp_img_main_var_img__js").addClass("hiddenImg");
    $('.pp_img_main_var_img__js[data-id="' + variantId + '"]').removeClass(
      "hiddenImg"
    );
  }

  function calculateTotalItems() {
    var totalItems = 0;
    $(".pp_builder_var_qty").each(function () {
      var thisQuantity = parseFloat($(this).find(".pp_var_qty_value").html());
      totalItems += thisQuantity;
    });

    var currency = String($(".pp_bundle_pricing").attr("data-currency"));
    currency = currency.replace("00", "").replace("0", "");

    console.log(totalItems, "TOTAL ITEMS IN BUILDER");

    // reset
    $('.pp_builder-point').removeClass('active');
    $('.pp_builder-progress-line_box').removeClass('active');
    $('.pp_builder-line__in').css('width', '0%');

    // LINE 1: items 1 → 3
    let line1Progress = 0;
    if (totalItems > 0) {
    line1Progress = Math.min((totalItems / 3) * 100, 100);
    }

    // LINE 2: items 3 → 5
    let line2Progress = 0;
    if (totalItems > 3) {
    line2Progress = Math.min(((totalItems - 3) / 2) * 100, 100);
    }

   

    // activate points + labels
    if (totalItems >= 1) {
    $('.pp_builder-point[data="1"]').addClass('active');
    $('.pp_builder-progress-line_box[data="1"]').addClass('active');
    $('.pp_builder-line[data="1"] .pp_builder-line__in')
    .css('width', line1Progress + '%');
    $('.pp_builder-line[data="2"] .pp_builder-line__in')
    .css('width', '0%');
    }

    if (totalItems >= 3) {
    $('.pp_builder-point[data="2"]').addClass('active');
    $('.pp_builder-progress-line_box[data="2"]').addClass('active');
    $('.pp_builder-line[data="1"] .pp_builder-line__in')
    .css('width', '100%');
     $('.pp_builder-line[data="2"] .pp_builder-line__in')
    .css('width', line2Progress + '%');
    }

    if (totalItems >= 5) {
    $('.pp_builder-point[data="3"]').addClass('active');
    $('.pp_builder-progress-line_box[data="3"]').addClass('active');
    }

  }

  $(".pp_builder_mode_freq_box").click(function () {
    $(".pp_builder_mode_freq_box").removeClass("active");
    $(this).addClass("active");
  });

  $(".pp_builder_mode_box").click(function () {
    $(".pp_builder_mode_box").removeClass("active");
    $(this).addClass("active");

    var mode = $(this).attr("data");
    if (mode == "sub") {
      $(".pp_sub_gifts_box").show();
    } else {
      $(".pp_sub_gifts_box").hide();
    }
  });

  $(document).scroll(function () {
    if ($(document).scrollTop() >= 700) {
      $(".ppb_outer.sticky_bar").addClass("active");
    } else {
      $(".ppb_outer.sticky_bar").removeClass("active");
    }
  });

  $(".pp_bundle_option").click(function () {
    $(".pp_bundle_option").removeClass("pp_bundle_selected");
    $(this).addClass("pp_bundle_selected");
    var mode = $(this).attr("mode");

    if (mode == "sub") {
      $(".pp_bundle_pricing").addClass("hidded");
      $(".pp_bundle_pricing.subPricing").removeClass("hidded");
    } else {
      $(".pp_bundle_pricing").addClass("hidded");
      $(".pp_bundle_pricing.otpPricing").removeClass("hidded");
    }
  });

  $(function () {
    const days = ["Sun.", "Mon.", "Tue.", "Wed.", "Thu.", "Fri.", "Sat."];
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const date = new Date();
    date.setDate(date.getDate() + 4);

    const day = days[date.getDay()];
    const month = months[date.getMonth()];
    const dayNum = date.getDate();

    const formattedDate = `${day} ${month}, ${dayNum}`;

    $(".pp_timeline_date").text(formattedDate);
  });

  $(".pp_bundle_freq_selection").change(function () {
    var currentLoop = $(this).val();
    $(".pp_builder_var_qty").each(function () {
      var newId = $(this)
        .find('.pp_freq_selection__js[data-loop="' + currentLoop + '"]')
        .attr("data-id");
      $(this).attr("data-selling-plan", newId);
    });
  });

  $(".pp_var_autoship").click(function () {
    $(this).toggleClass("disabled");
    if ($(".pp_var_autoship").hasClass("disabled")) {
      $('.pp_bundle_option[mode="otp"]').find("input").trigger("click");
    } else {
      $('.pp_bundle_option[mode="sub"]').find("input").trigger("click");
    }
  });

  var isAddingBundle = false;

  $('.pr_bundle-atc-btn').click(async function(){
    // Ignore repeated clicks while the add + coupon flow is running
    if (isAddingBundle) return;

    var items = [];
     
     var subActive = true;
     if ($('.pp_var_autoship').hasClass('disabled')){
        subActive = false;
     }

      $(".pp_builder_var_qty.hasItem").each(function () {
        const itemId = $(this).attr("data-id");
        const itemQty = $(this).find(".pp_var_qty_value").html();
        const itemSellingPlan = $(this).attr("data-selling-plan");

        if (subActive == true){
            const item = {
                id: itemId,
                quantity: itemQty,
                selling_plan: itemSellingPlan
            };
            items.push(item);
        }
        else{
            const item = {
                id: itemId,
                quantity: itemQty
            };
            items.push(item);
        }
        
      });

      console.log(items, 'ITEMS');

    var totalItems = 0;
    items.forEach(function (item) {
      totalItems += parseFloat(item.quantity);
    });
    var discountCode = getBundleDiscountCode(totalItems, subActive);

    if (!items.length) return;

    var $atcBtn = $(this);
    isAddingBundle = true;
    $atcBtn.addClass("is-loading").attr("aria-busy", "true");

    try {
      await $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: { items: items },
        dataType: "json",
      });

      await applyBundleDiscount(discountCode);

      // Let the cart drawer (Kaching) re-render with the final discount
      if (window.kachingCartApi && window.kachingCartApi.refreshCart) {
        await window.kachingCartApi.refreshCart();
      }
    } catch (error) {
      console.error(error, 'BUNDLE ADD TO CART ERROR');
    } finally {
      isAddingBundle = false;
      $atcBtn.removeClass("is-loading").removeAttr("aria-busy");
    }

  });

  // Replaces every discount code in the cart with `code` (or clears them when empty)
  // and confirms it stuck, retrying when another cart script overwrote it in the meantime.
  async function applyBundleDiscount(code) {
    var maxAttempts = 4;

    for (var attempt = 1; attempt <= maxAttempts; attempt++) {
      // Sending a single code replaces any existing ones, so clearing and applying is one atomic request
      await updateCartDiscount(code);

      // Give other cart listeners (e.g. Kaching) time to finish their own updates before checking
      await wait(400 * attempt);

      var cart = await $.ajax({ type: "GET", url: "/cart.js", dataType: "json" });
      if (cartHasOnlyDiscount(cart, code)) return cart;

      console.warn('Bundle discount not applied yet, retrying (' + attempt + '/' + maxAttempts + ')');
    }

    console.error('Bundle discount could not be applied: ' + code);
  }

  function cartHasOnlyDiscount(cart, code) {
    var codes = (cart.discount_codes || []).map(function (discount) {
      return discount.code.toLowerCase();
    });
    if (!code) return codes.length === 0;
    return codes.length === 1 && codes[0] === code.toLowerCase();
  }

  function wait(ms) {
    return new Promise(function (resolve) {
      setTimeout(resolve, ms);
    });
  }

  // Coupon codes come from the bundle collection metafields (custom.buy_X_get_Y_coupon_otp/sub)
  function getBundleDiscountCode(totalItems, subActive) {
    var $atcBtn = $(".pr_bundle-atc-btn");
    var suffix = subActive ? "sub" : "otp";
    if (totalItems >= 5) {
      return $atcBtn.attr("data-coupon-tier2-" + suffix) || "";
    }
    if (totalItems >= 3) {
      return $atcBtn.attr("data-coupon-tier1-" + suffix) || "";
    }
    return "";
  }

  function updateCartDiscount(code) {
    return $.ajax({
      type: "POST",
      url: "/cart/update.js",
      data: JSON.stringify({ discount: code }),
      contentType: "application/json",
      dataType: "json",
    });
  }


});
